/**
 * 出纳管理 API
 */
import Ajax from '../js/common/ajax';
import Qs from "qs";

export default {
	// ========== 出纳账户 ==========
	// 获取账户列表
	getCashierAccounts() {
		return Ajax.get("/cashier/accounts")
	},
	// 按类型获取账户
	getCashierAccountsByType(type) {
		return Ajax.get(`/cashier/accounts/by-type/${type}`)
	},
	// 获取单个账户
	getCashierAccount(id) {
		return Ajax.get(`/cashier/accounts/${id}`)
	},
	// 创建账户
	createCashierAccount(params = {}) {
		return Ajax.post("/cashier/accounts", params)
	},
	// 更新账户
	updateCashierAccount(id, params = {}) {
		return Ajax.put(`/cashier/accounts/${id}`, params)
	},
	// 删除账户
	deleteCashierAccount(id) {
		return Ajax.delete(`/cashier/accounts/${id}`)
	},
	// 获取账户类型
	getCashierAccountTypes() {
		return Ajax.get("/cashier/accounts/types")
	},

	// ========== 出纳日记账 ==========
	// 获取日记账列表
	getCashierJournals() {
		return Ajax.get("/cashier/journals")
	},
	// 按账户和日期范围查询日记账
	getCashierJournalsByAccount(accountId, startDate, endDate) {
		return Ajax.get(`/cashier/journals/by-account/${accountId}?startDate=${startDate}&endDate=${endDate}`)
	},
	// 获取单个日记账
	getCashierJournal(id) {
		return Ajax.get(`/cashier/journals/${id}`)
	},
	// 创建日记账记录
	createCashierJournal(params = {}) {
		return Ajax.post("/cashier/journals", params)
	},
	// 更新日记账记录
	updateCashierJournal(id, params = {}) {
		return Ajax.put(`/cashier/journals/${id}`, params)
	},
	// 删除日记账记录
	deleteCashierJournal(id) {
		return Ajax.delete(`/cashier/journals/${id}`)
	},
	// 获取账户余额
	getCashierAccountBalance(accountId) {
		return Ajax.get(`/cashier/journals/balance/${accountId}`)
	},
	// 获取日记账类型
	getCashierJournalTypes() {
		return Ajax.get("/cashier/journals/types")
	},

	// ========== 资金调拨 ==========
	// 获取调拨记录列表
	getCashierTransfers() {
		return Ajax.get("/cashier/transfers")
	},
	// 按日期范围查询调拨记录
	getCashierTransfersByDate(startDate, endDate) {
		return Ajax.get(`/cashier/transfers/by-date?startDate=${startDate}&endDate=${endDate}`)
	},
	// 获取单个调拨记录
	getCashierTransfer(id) {
		return Ajax.get(`/cashier/transfers/${id}`)
	},
	// 执行资金调拨
	executeCashierTransfer(params = {}) {
		return Ajax.post("/cashier/transfers", params)
	},
	// 更新调拨记录
	updateCashierTransfer(id, params = {}) {
		return Ajax.put(`/cashier/transfers/${id}`, params)
	},
	// 删除调拨记录
	deleteCashierTransfer(id) {
		return Ajax.delete(`/cashier/transfers/${id}`)
	},

	// ========== 收支类型 ==========
	// 获取收支类型列表
	getCashierIoTypes() {
		return Ajax.get("/cashier/io-types")
	},
	// 按类型获取收支类型
	getCashierIoTypesByType(type) {
		return Ajax.get(`/cashier/io-types/by-type/${type}`)
	},
	// 获取单个收支类型
	getCashierIoType(id) {
		return Ajax.get(`/cashier/io-types/${id}`)
	},
	// 创建收支类型
	createCashierIoType(params = {}) {
		return Ajax.post("/cashier/io-types", params)
	},
	// 更新收支类型
	updateCashierIoType(id, params = {}) {
		return Ajax.put(`/cashier/io-types/${id}`, params)
	},
	// 删除收支类型
	deleteCashierIoType(id) {
		return Ajax.delete(`/cashier/io-types/${id}`)
	},
	// 获取收支类型枚举
	getCashierIoTypeEnums() {
		return Ajax.get("/cashier/io-types/types")
	}
}
